import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import { X, Info, AlertTriangle, CheckCircle, Megaphone } from 'lucide-react';

const DISMISSED_ANNOUNCEMENTS_KEY = 'pharmaconsensus_dismissed_announcements';

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    fetchActiveAnnouncement();
  }, []);

  const fetchActiveAnnouncement = async () => {
    try {
      const response = await api.get('/announcements/active');
      if (response.data) {
        // Check if user has already dismissed this announcement
        const dismissedIds = getDismissedAnnouncementIds();
        if (!dismissedIds.includes(response.data.id)) {
          setAnnouncement(response.data);
          setIsVisible(true);
        }
      }
    } catch (error) {
      // Silently fail - announcement is optional
      console.error('Failed to fetch announcement:', error);
    }
  };

  const getDismissedAnnouncementIds = () => {
    try {
      const stored = localStorage.getItem(DISMISSED_ANNOUNCEMENTS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  };

  const dismissAnnouncement = () => {
    if (announcement) {
      const dismissedIds = getDismissedAnnouncementIds();
      if (!dismissedIds.includes(announcement.id)) {
        dismissedIds.push(announcement.id);
        localStorage.setItem(DISMISSED_ANNOUNCEMENTS_KEY, JSON.stringify(dismissedIds));
      }
    }
    setIsVisible(false);
  };

  if (!isVisible || !announcement) {
    return null;
  }

  const getTypeStyles = () => {
    switch (announcement.type) {
      case 'warning':
        return {
          bg: 'bg-gradient-to-r from-amber-600 to-amber-500',
          icon: <AlertTriangle className="w-5 h-5" />,
          text: 'text-white'
        };
      case 'success':
        return {
          bg: 'bg-gradient-to-r from-emerald-600 to-emerald-500',
          icon: <CheckCircle className="w-5 h-5" />,
          text: 'text-white'
        };
      default: // info
        return {
          bg: 'bg-gradient-to-r from-indigo-600 to-indigo-500',
          icon: <Info className="w-5 h-5" />,
          text: 'text-white'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div className={`${styles.bg} ${styles.text} relative z-50`}>
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-center gap-3">
          <div className="flex items-center gap-2">
            <Megaphone className="w-5 h-5 flex-shrink-0" />
            {styles.icon}
          </div>
          <p className="text-sm md:text-base font-medium text-center">
            {announcement.message}
          </p>
          <button
            onClick={dismissAnnouncement}
            className="ml-4 p-1 hover:bg-white/20 rounded-full transition-colors flex-shrink-0"
            aria-label="Dismiss announcement"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
